import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Rols } from 'src/app/core/entities/rols.model';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Utils } from 'src/app/core/utils/utils';
import { EditDialogsRolinternalComponent } from './dialogs-rolinternal/edit-dialogs-rolinternal/edit-dialogs-rolinternal.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-rolinternal',
  templateUrl: './rolinternal.component.html',
  styleUrls: ['./rolinternal.component.scss']
})
export class RolinternalComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  rolsInternal: Rols = new Rols();

  mensajeError: boolean = false;

  constructor(public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService,
    private route: ActivatedRoute,
    private router: Router) {
    super();
  }

  ngOnInit(): void {
    this.mensajeError = false;
    this.getAllRolsInternal();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla rols
  */
  private getAllRolsInternal(): void {
    this.loading = true;
    this.internalHomeService.allRolsInternal().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un rol internal
  * @param rolsExternal Opcional. rolsInternal vacio.
  */
  public createRolsInternal(rolsInternal?: Rols) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = false;
    rolsInternal = this.rolsInternal;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsRolinternalComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { rolsInternal, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllRolsInternal();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un rol internal
  * @param rolsExternal Opcional. Rol internal a editar.
  */
  public editRolsInternal(rolsInternal?: Rols) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsRolinternalComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { rolsInternal, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllRolsInternal();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un rol Internal
  * @param rolsExternal Rol internal a eliminar
  */
  public removeRolsInternal(rolsInternal?: Rols) {
    Utils.toggleAllButtonsAndHref(null);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_rolinternal') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(null);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeRolsInternal(rolsInternal).subscribe(res => {
          console.log(res);
          this.getAllRolsInternal();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
